import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from '@mui/material';
import { SetKioskThemeDtoTheme } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryClient } from 'react-query';
import { QueryKeys } from '../../../../core/queries/query-keys.constants';
import { useMutationSetKioskTheme } from '../../../lockers/kiosks.queries';
import { KIOSK_THEME_PRESET_OPTIONS } from '../../forms/kiosk-theme-form/kiosk-theme-presets';

export function ApplyKioskThemePresetModal(props: {
  kioskId: string;
  projectId: string;
  onSuccess: () => void;
  onCancel: () => void;
}) {
  const [selected, setSelected] = useState<SetKioskThemeDtoTheme | ''>('');
  const mutation = useMutationSetKioskTheme();
  const queryClient = useQueryClient();

  const onApply = async () => {
    if (!selected) return;
    await mutation.mutateAsync({ kioskID: props.kioskId, theme: selected, projectID: props.projectId });
    await queryClient.refetchQueries([QueryKeys.KIOSKS, props.kioskId]);
    props.onSuccess();
  };

  return (
    <Dialog open onClose={props.onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Apply preset</DialogTitle>
      <DialogContent>
        <FormControl variant="outlined" fullWidth size="small">
          <InputLabel>Preset</InputLabel>
          <Select
            value={selected}
            onChange={(e) => setSelected(e.target.value as SetKioskThemeDtoTheme)}
            label="Preset"
            disabled={mutation.isLoading}
          >
            {KIOSK_THEME_PRESET_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel} disabled={mutation.isLoading}>
          Cancel
        </Button>
        <Button onClick={onApply} color="primary" variant="contained" disabled={!selected || mutation.isLoading}>
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}
